import { useSelector } from "@/store";

export function useStepper() {
  return useSelector((state) => state.stepper);
}
